import { Wrench } from '@gravity-ui/icons'
import { Button, Table, Tooltip } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import type { UiWarehouseState } from '@/store/warehouse.store'

interface WarehouseStateTableProps {
  stateList: UiWarehouseState[];
  onInstall: (articleName: string) => void;
}

export function WarehouseStateTable({ stateList, onInstall }: WarehouseStateTableProps) {
  const { t } = useTranslation()

  return (
    <Table className="min-h-[200px]">
      <Table.ScrollContainer className="max-h-[calc(100vh-theme(spacing.48))]">
        <Table.Content aria-label={t('warehouse.state_table_label')}>
          <Table.Header className="sticky top-0 z-10">
            <Table.Column id="name">{t('warehouse.article_name')}</Table.Column>
            <Table.Column id="count">{t('warehouse.total_count')}</Table.Column>
            <Table.Column id="total_value">{t('warehouse.total_value')}</Table.Column>
            <Table.Column id="actions" className="w-12" />
          </Table.Header>
          <Table.Body>
            {stateList.map((item, idx) => {
              const totalValue = item.count * item.cost
              return (
                <Table.Row key={idx} className="hover:bg-default-50">
                  <Table.Cell>
                    <span className="font-bold text-foreground">{item.name}</span>
                  </Table.Cell>
                  <Table.Cell>
                    <span className="font-semibold">{item.count}</span>
                  </Table.Cell>
                  <Table.Cell>
                    <span className="font-bold text-foreground">{totalValue.toFixed(2).replace('.', ',')} BYN</span>
                  </Table.Cell>
                  <Table.Cell>
                    <div className="flex justify-end">
                      <Tooltip delay={0}>
                        <Button
                          isIconOnly
                          size="sm"
                          variant="tertiary"
                          isDisabled={item.count === 0}
                          onClick={e => {
                            e.stopPropagation()
                            onInstall(item.name)
                          }}
                        >
                          <Wrench className="size-4 text-default-500" />
                        </Button>
                        <Tooltip.Content>
                          <p>{t('warehouse.action_install')}</p>
                        </Tooltip.Content>
                      </Tooltip>
                    </div>
                  </Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table.Content>
      </Table.ScrollContainer>
    </Table>
  )
}
